module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.recipient && _vm.recipient.id) ? _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressRecipient),
      expression: "progressRecipient"
    }],
    staticClass: "tab-content"
  }, [(_vm.recipient) ? _c('div', [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [(parseInt(_vm.recipient.type) === 1 || parseInt(_vm.recipient.type) === 3) ? _c('div', {
    staticClass: "md-layout-item md-caption"
  }, [_vm._v("Юридическое лицо")]) : _vm._e(), (parseInt(_vm.recipient.type) === 2) ? _c('div', {
    staticClass: "md-layout-item md-caption"
  }, [_vm._v("Физическое лицо")]) : _vm._e()]), (parseInt(_vm.recipient.type) === 1 || parseInt(_vm.recipient.type) === 3) ? _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.inn) ? _c('md-field', [_c('label', [_vm._v("ИНН")]), _c('md-input', {
    attrs: {
      "name": "recipient_inn",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.inn),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "inn", $$v)
      },
      expression: "recipient.inn"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.kpp && parseInt(_vm.recipient.type) === 1) ? _c('md-field', [_c('label', [_vm._v("КПП")]), _c('md-input', {
    attrs: {
      "name": "recipient_kpp",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.kpp),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "kpp", $$v)
      },
      expression: "recipient.kpp"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-100"
  }, [(_vm.recipient.name) ? _c('md-field', [_c('label', [_vm._v("Наименование")]), _c('md-input', {
    attrs: {
      "name": "recipient_name",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.name),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "name", $$v)
      },
      expression: "recipient.name"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), (parseInt(_vm.recipient.type) === 2) ? _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.name) ? _c('md-field', [_c('label', [_vm._v("ФИО")]), _c('md-input', {
    attrs: {
      "name": "recipient_name",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.name),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "name", $$v)
      },
      expression: "recipient.name"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.passport_number) ? _c('md-field', [_c('label', [_vm._v("Номер паспорта")]), _c('md-input', {
    attrs: {
      "name": "recipient_passport_number",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.passport_number),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "passport_number", $$v)
      },
      expression: "recipient.passport_number"
    }
  })], 1) : _vm._e()], 1)]) : _vm._e(), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.checking_account) ? _c('md-field', [_c('label', [_vm._v("Номер расчётного счёта")]), _c('md-input', {
    attrs: {
      "name": "recipient_checking_account",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.checking_account),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "checking_account", $$v)
      },
      expression: "recipient.checking_account"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.correspondent_account) ? _c('md-field', [_c('label', [_vm._v("Номер корреспонденского счёта")]), _c('md-input', {
    attrs: {
      "name": "recipient_correspondent_account",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.correspondent_account),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "correspondent_account", $$v)
      },
      expression: "recipient.correspondent_account"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.bic) ? _c('md-field', [_c('label', [_vm._v("БИК")]), _c('md-input', {
    attrs: {
      "name": "recipient_bic",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.bic),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "bic", $$v)
      },
      expression: "recipient.bic"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.bank) ? _c('md-field', [_c('label', [_vm._v("Банк")]), _c('md-input', {
    attrs: {
      "name": "recipient_bank",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.bank),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "bank", $$v)
      },
      expression: "recipient.bank"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.phone) ? _c('md-field', [_c('label', [_vm._v("Телефон")]), _c('md-input', {
    attrs: {
      "name": "recipient_phone",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.phone),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "phone", $$v)
      },
      expression: "recipient.phone"
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item md-size-50"
  }, [(_vm.recipient.email) ? _c('md-field', [_c('label', [_vm._v("Email")]), _c('md-input', {
    attrs: {
      "name": "recipient_email",
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.recipient.email),
      callback: function($$v) {
        _vm.$set(_vm.recipient, "email", $$v)
      },
      expression: "recipient.email"
    }
  })], 1) : _vm._e()], 1)]), (_vm.contacts && _vm.contacts.length) ? _c('div', [_c('div', {
    staticClass: "md-caption"
  }, [_vm._v("Контактные лица")]), _vm._l((_vm.contacts), function(contact, i) {
    return _c('div', {
      staticClass: "md-layout md-gutter"
    }, [(contact.contact && contact.contact.name) ? _c('div', {
      staticClass: "md-layout-item md-size-33"
    }, [_c('span', [_vm._v(_vm._s(contact.contact.name))])]) : _vm._e(), (contact.contact && contact.contact.phone) ? _c('div', {
      staticClass: "md-layout-item md-size-33"
    }, [_c('span', [_vm._v(_vm._s(contact.contact.phone))])]) : _vm._e(), (contact.contact && contact.contact.email) ? _c('div', {
      staticClass: "md-layout-item md-size-33"
    }, [_c('span', [_vm._v(_vm._s(contact.contact.email))])]) : _vm._e()])
  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59c6cd46","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/storekeepers_stocks/views/forms/recipient.vue
// module id = 1153
// module chunks = 0